import React from 'react';
import { createPortal } from 'react-dom';
import './index.scss';

export default function ImagePreviewModal({ show, image, title, info = [], onClose, onDownload }) {
  if (!show) return null;
  const modal = (
    <div className="image-preview-modal" onClick={onClose}>
      <div className="image-preview-modal-content" onClick={e => e.stopPropagation()}>
        <div className="image-preview-modal-header">
          <h3>{title}</h3>
          <button className="image-preview-modal-close" onClick={onClose}>✕</button>
        </div>
        <div className="image-preview-modal-body">
          <img src={image} alt={title} />
          {info.length > 0 && (
            <div className="image-preview-modal-info">
              {info.map((line, i) => <p key={i}>{line}</p>)}
            </div>
          )}
        </div>
        <div className="image-preview-modal-actions">
          {onDownload && (
            <button className="image-preview-modal-btn" onClick={onDownload}>下载图片</button>
          )}
        </div>
      </div>
    </div>
  );
  return createPortal(modal, document.body);
} 